var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46C35.7025 46 46 35.7025 46 23Z",
    fill: "#28A998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2348 21.3594L14.5473 10.1223C14.2154 9.93613 13.8348 9.85534 13.4559 9.89067C13.077 9.92599 12.7179 10.0757 12.4261 10.32C12.1344 10.5643 11.9239 10.8916 11.8226 11.2584C11.7213 11.6251 11.734 12.0141 11.859 12.3735L15.4918 22.9754C15.4913 22.9793 15.4913 22.9832 15.4918 22.9871C15.4911 22.991 15.4911 22.995 15.4918 22.9988L11.859 33.6242C11.7589 33.907 11.7281 34.2096 11.7691 34.5066C11.8102 34.8037 11.9219 35.0866 12.0949 35.3316C12.2679 35.5766 12.4971 35.7765 12.7634 35.9146C13.0296 36.0526 13.3251 36.1248 13.625 36.125C13.9504 36.1242 14.2701 36.0394 14.5531 35.8789L34.2301 24.6231C34.5203 24.4605 34.7621 24.2236 34.9305 23.9367C35.099 23.6498 35.1881 23.3233 35.1887 22.9906C35.1893 22.6579 35.1014 22.3311 34.9339 22.0436C34.7665 21.7561 34.5256 21.5183 34.2359 21.3547L34.2348 21.3594ZM13.625 34.25V34.2395L17.157 23.9375H23.9375C24.1861 23.9375 24.4246 23.8387 24.6004 23.6629C24.7762 23.4871 24.875 23.2487 24.875 23C24.875 22.7514 24.7762 22.5129 24.6004 22.3371C24.4246 22.1613 24.1861 22.0625 23.9375 22.0625H17.1664L13.632 11.7641L13.625 11.75L33.3125 22.9801L13.625 34.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/send-button.5a3014b12388a2e31a25c18132ae0f81.svg";
export { ForwardRef as ReactComponent };